import { useState, useEffect } from 'react';

import { showError } from '@utils';
import { getTabs } from 'components/vehicles/FleetVehicleMenu/utils';
import { useRouter } from 'next/router';

export const useFleetVehicleHandlers = ({
  vehicle,
  vehicleId,
  getVehicle,
  getFleetVehicleChangelog,
}) => {
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const tabs = getTabs(vehicle?.stage?.newStageId?.defaultValue);
  const initialActiveTab = tabs.findIndex(
    (tab) => tab.key === (router.query?.tab || 'overview')
  );
  const [activeTab, setTab] = useState(initialActiveTab);

  const handleEditPricing = async (data) => {
    if (data?.pricing?.length === 0) {
      showError('Please add at least one pricing option');
      return;
    }
    try {
      setLoading(true);
      console.log('handleEditPricing', data); // eslint-disable-line no-console
      // await getVehicle();
    } catch (error) {
      showError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleRefresh = () => getVehicle({ loading: true });

  useEffect(() => {
    if (activeTab === 2) {
      getFleetVehicleChangelog(vehicleId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, vehicleId]);

  return {
    activeTab,
    loading,
    setTab,
    handleRefresh,
    handleEditPricing,
  };
};

export default useFleetVehicleHandlers;
